'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresAcceptTerms]');

var WinresAcceptTermsController = function () {
    function WinresAcceptTermsController($scope, $q, userService, localizationService, cancelService) {
        _classCallCheck(this, WinresAcceptTermsController);

        this.$scope = $scope;
        this.$q = $q;
        this.userService = userService;
        this.localizationService = localizationService;
        this.cancelService = cancelService;
    }

    _createClass(WinresAcceptTermsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.context.getContext();
            this.$scope.$watchCollection(function () {
                return _this.data.Products;
            }, function (lines) {
                return _this.onProductLinesChange(lines);
            });
        }
    }, {
        key: 'onProductLinesChange',
        value: function onProductLinesChange(lines) {
            // log(`Product lines changed:`, lines);
            this.getPolicies(lines);
        }
    }, {
        key: 'getPolicies',
        value: function getPolicies(lines) {
            var _this2 = this;

            if (this.promise) {
                this.cancelService.cancel(this.promise);
            }

            var lang = this.localizationService.getLanguage();

            var destInfos = _.filter(_.map(lines, function (line) {
                return line && line.Product && line.Product.DestinationInfo;
            }), function (x) {
                return x;
            });

            var destInfosByDestCode = _.groupBy(destInfos, function (di) {
                return di.DestinationCode;
            });

            var subPromises = _.map(destInfosByDestCode, function (dis, destCode) {
                var request = _this2.userService.getDestinationPrivacyPolicy(destCode, lang);
                return request.then(function (link) {
                    return {
                        destCode: destCode,
                        name: dis[0].DestinationName || dis[0].ProductName,
                        link: link
                    };
                });
            });

            this.promise = this.$q.all(subPromises).then(function (results) {
                return _.filter(results, function (r) {
                    return r.link;
                });
            });
        }
    }]);

    return WinresAcceptTermsController;
}();

WinresAcceptTermsController.$inject = ['$scope', '$q', 'userService', 'localizationService', 'cancelService'];

_module3.default.component('winresAcceptTerms', {
    template: require('./winresAcceptTerms.html'),
    controller: WinresAcceptTermsController,
    bindings: {
        context: '<',
        showLegend: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAcceptTerms/winresAcceptTerms.js
// module id = 526
// module chunks = 2